import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { SectorLocationService } from '../../../../../app/shared/API-Service/services/sector-location.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'



@Component({
  selector: 'app-view-sector-location',
  templateUrl: './view-sector-location.component.html',
  styleUrls: ['./view-sector-location.component.css']
})
export class ViewSectorLocationComponent implements OnInit {
  sectorlocation:object [] = [];
  img : string = Image;
  constructor(private _SectorLocationService:SectorLocationService,private _Router:Router) { }

  ngOnInit(): void {
    this.getsectorlocation();
  }
  getsectorlocation(){
    this._SectorLocationService.GetSectorLocation().subscribe((res) => {
      this.sectorlocation = res.data 
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(data){
    this._SectorLocationService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertSectorLocation']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._SectorLocationService.DeleteSectorLocation(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getsectorlocation();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
